import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { rsvpService } from '../services/rsvpService';
import { RSVP_KEYS } from './queryKeys';
import type { SubmitRsvpInput } from '../types/rsvp';

export const useMyRsvp = (eventId: string) => {
  return useQuery({
    queryKey: RSVP_KEYS.myRsvp(eventId),
    queryFn: () => rsvpService.getMyRsvp(eventId),
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useSubmitRsvp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SubmitRsvpInput) => rsvpService.submitRsvp(data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.myRsvp(variables.eventId) });
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.eventRsvps(variables.eventId) });
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.stats(variables.eventId) });
    },
  });
};

export const useDeleteRsvp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (eventId: string) => rsvpService.deleteMyRsvp(eventId),
    onSuccess: (_data, eventId) => {
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.myRsvp(eventId) });
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.eventRsvps(eventId) });
      queryClient.invalidateQueries({ queryKey: RSVP_KEYS.stats(eventId) });
    },
  });
};

export const useEventRsvps = (eventId: string) => {
  return useQuery({
    queryKey: RSVP_KEYS.eventRsvps(eventId),
    queryFn: () => rsvpService.getEventRsvps(eventId),
    enabled: !!eventId,
  });
};

export const useRsvpStats = (eventId: string) => {
  return useQuery({
    queryKey: RSVP_KEYS.stats(eventId),
    queryFn: () => rsvpService.getRsvpStats(eventId),
    enabled: !!eventId,
  });
};
